"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DIMENSIONS = exports.KEYS = void 0;
exports.KEYS = {
    ARROW_DOWN: "ArrowDown",
    ARROW_UP: "ArrowUp",
    ARROW_LEFT: "ArrowLeft",
    ARROW_RIGHT: "ArrowRight",
    IE_ARROW_DOWN: "Down",
    IE_ARROW_UP: "Up",
    IE_ARROW_LEFT: "Left",
    IE_ARROW_RIGHT: "Right",
    ENTER: "Enter",
    ESCAPE: "Escape",
    SPACE: "Space",
};
exports.DIMENSIONS = {
    MEDIUM: "medium",
    SMALL: "small",
};
//# sourceMappingURL=config.js.map